import * as types from './mutation-types'

export default {
  setCurrentCampaign ({ commit }, payload) {
    commit(types.SET_CURRENT_CAMPAIGN, payload)
  }
}
